/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { Page, CategoryHeader, SubCatCard } from "../components";
import { getFromQueryString } from "../utilities";

export default function CategoryPage(props) {
  const productsInSubCat = props.pageContext;
  const { search } = props.location;
  return (
    <Page className={"CatergoriesPage"} title={"Categories"}>
      <CategoryHeader
        renderCatNameOnly
        product={Object.values(productsInSubCat)[0][0]}
        visitorName={getFromQueryString(search, "mi_name")}
      />
      <section
        style={{ paddingTop: "30px", paddingBottom: "130px" }}
        className="featured"
      >
        <div className="container">
          <div className="row">
            {Object.keys(productsInSubCat).map((subCatName, key) => {
              return (
                <SubCatCard
                  key={key}
                  subCatURL={subCatName}
                  product={productsInSubCat[subCatName][0]}
                />
              );
            })}
            <br />
          </div>
        </div>
      </section>
    </Page>
  );
}
